import { Input, Select } from '@/components'
import Card from '@/components/Form/Card'
import { estados } from '@/components/Form/Form.data'

import { ClientFieldsProps } from './ClientDataFields.type'

const ClientDataFields = ({ formData, onChange }: ClientFieldsProps) => (
  <Card title="Dados do Cliente">
    <div className="flex flex-col gap-4">
      <Input
        label="Razão Social"
        placeholder="Digite a Razão Social"
        value={formData?.Cliente_RZC2}
        onChange={onChange}
        required
        name="Cliente_RZC2"
      />
      <Input
        label="CNPJ"
        maxLength={14}
        placeholder="Digite o CNPJ (Somente números)"
        value={formData?.Cliente_CNPJC2}
        onChange={onChange}
        required
        name="Cliente_CNPJC2"
      />
      <Input
        label="Endereço"
        placeholder="Digite a rua, número, bairro e complemento"
        value={formData?.street}
        onChange={onChange}
        required
        name="street"
      />
      <Input
        label="Cidade"
        placeholder="Digite cidade"
        value={formData?.city}
        onChange={onChange}
        required
        name="city"
      />
      <Select
        name="state"
        label="Estado"
        selectedValue={formData?.state || ''}
        options={estados}
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        onChange={onChange}
        center={false}
      />
      <Input
        label="CEP"
        placeholder="Digite o CEP (Somente números)"
        value={formData?.postalCode}
        onChange={onChange}
        required
        name="postalCode"
      />
    </div>
  </Card>
)

export default ClientDataFields
